<style lang="stylus" scoped>
.address-area{
    overflow :hidden;
    // padding: 16px 0px;
    background: #fff;
.province_btn{
    width :56px;
    height :2em;
    border-radius: 30px;
    line-height: 2;
    text-align: center;
    font-size: 14px;
    float: left;
    cursor: pointer;
    // margin-left: 30px;
    color: #333333;
    user-select none;
    margin: 10px 15px 10px 15px 
}
// .province_btn:nth-child(12n+1){
//     margin-left: 0;
// }
// .province_btn:first-child{
//     margin-left: 0;
// }
.active_btn{
    background: #53a0e9;
    color: #ffffff;
}
}
</style>
<template>
   <div class="address-area" v-if="items.length>0" >
        <div class="province_btn" :class="{'active_btn':index == num}" @click="provinceEvent(index)" v-for="(it,index) in items" :key='index'>{{it.nameName}}</div>
        <div class="province_btn"  @click="openMove" style='color:#508ED7;' v-if='items.length>9'>{{isMove?'更多':'收起'}}</div>
    </div>
</template>

<script>
import Bus from '@/utils/Bus.js'
export default {
    name: 'mapDataTable',
    data () {
        return {
            items: [],
            allArr: [],
            num:0,//当前点击的元素
            isMove:true
        };
    },
    props: {
        areaList:Array,
        changeCity:Function,
    },
    created(){
        let newarr=[];
        let list = [{
            nameName:'合计'
        }].concat(this.areaList);
        list.forEach(e=>{
                newarr.push(e);
        });
        this.allArr = [...newarr];
        newarr=JSON.stringify(newarr);
        this.items=JSON.parse(newarr).slice(0,11);
    },
    methods:{
        provinceEvent(index,it){
            this.num = index;
            this.changeCity(index-1);
        },
        openMove(){
            let arr = this.allArr;
            if(this.isMove){
                this.items = [...arr];
            }else{
                this.items = arr.slice(0,11)
            }
            this.isMove = !this.isMove;
        }
    }
};
</script>
